import React from 'react';
import Table    from '../../../../components/Table';
import View from './ViewPersonal';
import ViewInmuebles from './ViewPersonalInmuebles';
import usePermissions from '../../../../hooks/usePermissions';
import useAsyncStorage     from '../../../../hooks/useAsyncStorage';
import useAxios      from '../../../../hooks/useAxios';

const td  = [
  {
    label:"Nombre",
    field:"name",
    className:"",
    align:"left",
  },
  {
    label:"Cargo",
    field:"cargo",
    className:"",
    align:"left",
  },
  {
    label:"Condominio",
    field:"condominio",
    className:"",
    align:"left",
  },
  {
    label:"Teléfono",
    field:"celular",
    className:"",
    align:"left",
  },
  {
    label:"Creador",
    field:"creador",
    className:"",
    align:"left",
  },
  {
    label:"Acción",
    field:"event",
    className:"",
    align:"center",
    event:[
      {
        label:"Ver",
        action:"view",
        component:View,
      },
      {
        label:"Comentarios",
        action:"comments",
        subFixed:"users_id_",
        component:true,
      },
      {
        label:"Inmuebles",
        action:"view",
        component:ViewInmuebles,
      },
    ]
  },
]
let axios
let userStorage
let inmueblesStorage
const Home=(props)=>{
  axios                 =   useAxios();
  userStorage           =   useAsyncStorage("perfiles");
  inmueblesStorage      =   useAsyncStorage("inmuebles");
  const permissions     =   usePermissions("clientes","index",{
                                                                component:Table,
                                                                td:td,
                                                                create:View,
                                                                subFixed:"/personal"
                                                              });

  React.useEffect(()=>{
    if (!userStorage.data) {
      const getInit=()=>{
        const endpoint    =  "api/"+process.env.REACT_APP_BACKEND_VERSION+"/info/roles"
        axios.getData({},endpoint).then((response)=>{
          if (response&&response.data) {
            userStorage.setData(response.data);
          }
        })
      }
      getInit()
    }
    if (!inmueblesStorage.data) {
      const endpoint    =  "api/"+process.env.REACT_APP_BACKEND_VERSION+document.location.pathname+"/info/inmuebles"
      axios.getData({},endpoint).then((response)=>{
        if (response&&response.data) {
          inmueblesStorage.setData(response.data);
        }
      })
    }
  },[])
  return  permissions.render()
}
export default Home
